import { useState, useEffect } from 'react';
import { Container, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { theme } from '../../lib/index';

function Vision({ visionData }) {
  const [ytLink, setYtLink] = useState('');

  useEffect(() => {
    if (visionData.video) {
      if (visionData.video.indexOf('watch') > -1) {
        setYtLink(`https://www.youtube.com/embed/${visionData.video.split('=')[1]}`);
      } else if (visionData.video.indexOf('youtu.be') > -1) {
        setYtLink(`https://www.youtube.com/embed/${visionData.video.split('/').slice(-1).join()}`);
      } else {
        setYtLink(visionData.video);
      }
    }
  }, [visionData]);

  return (
    <Wrapper>
      <Typography variant="h2">{visionData.vision}</Typography>
      <Typography className="bodytext">{visionData.detail}</Typography>
      { ytLink !== '' && (
        <VideoIframe
          src={ytLink}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Embedded youtube"
        />
      )}
    </Wrapper>
  );
}

export default Vision;

// Styling

const Wrapper = styled(Container, {})({
  '& .MuiTypography-h2': {
    fontSize: 20,

    [theme.breakpoints.up('laptop')]: {
      fontSize: 24,
    },

    [theme.breakpoints.up('laptop')]: {
      fontSize: 33,
    },
    marginBottom: 20,
  },

  '& .MuiTypography-h5': {
    marginBottom: 10,
  },

  '& .bodytext': {

    ...theme.typography.pSmall,

    marginBottom: '70px',

    whiteSpace: 'pre-wrap',

    [theme.breakpoints.up('laptop')]: {
      ...theme.typography.p,

      fontSize: 16,
    },
  },
});

const VideoIframe = styled('iframe', {})({
  width: '100%',
  minHeight: 250,

  aspectRatio: '3 / 2',
});
